<template>
  <!-- Sign up Box -->
  <v-card flat tile>
    <!-- Login / Sign up Tab -->
    <v-tabs grow hide-slider height="54">
      <v-tab
        :ripple="false"
        to="/login"
        class="primary darken-2 white--text"
        >{{ $langs.get("auth.login") }}</v-tab
      >
      <v-tab :ripple="false" to="/register">{{
        $langs.get("auth.signup")
      }}</v-tab>
    </v-tabs>

    <!-- Sign up Form -->
    <v-form ref="form" @submit.prevent="submit()" class="py-6 px-8">
      <!-- First -->
      <v-text-field
        class="rounded-sm"
        :label="$langs.get('myAccount.firstname')"
        type="text"
        v-model="account.firstname"
        autocomplete="off"
        :rules="rules.name"
        required
      ></v-text-field>

      <!-- Lastname -->
      <v-text-field
        class="rounded-sm"
        :label="$langs.get('myAccount.lastname')"
        type="text"
        v-model="account.lastname"
        autocomplete="off"
        :rules="rules.name"
        required
      ></v-text-field>

      <!-- Email -->
      <v-text-field
        class="rounded-sm"
        :label="$langs.get('auth.email')"
        type="email"
        v-model="account.email"
        autocomplete="off"
        :rules="rules.email"
        required
      ></v-text-field>

      <!-- Password -->
      <v-text-field
        class="rounded-sm"
        :label="$langs.get('auth.password')"
        :type="showField.password ? 'text' : 'password'"
        v-model="account.password"
        :append-icon="showField.password ? 'visibility' : 'visibility_off'"
        @click:append="showField.password = !showField.password"
        autocomplete="new-password"
        :rules="rules.password"
        required
      ></v-text-field>

      <!-- Confirm Password -->
      <v-text-field
        class="rounded-sm"
        :label="`${$langs.get('gen.confirm')}${
          $langs.get('space')
        }${$langs.get('auth.password')}`"
        type="password"
        v-model="account.rePassword"
        autocomplete="new-password"
        :rules="rules.matchingPassword"
        required
      ></v-text-field>

      <!-- :return-value.sync="account.birthdate" -->
      <v-menu
        v-model="datapicker"
        ref="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="account.birthdate"
            :label="$langs.get('myAccount.birthDate')"
            readonly
            v-bind="attrs"
            v-on="on"
            :rules="rules.required"
          ></v-text-field>
        </template>
        <v-date-picker v-model="account.birthdate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="datapicker = false">
            {{ $langs.get('gen.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(account.birthdate)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>

      <div class="grey--text text--darken-1">
        {{ $langs.get('myAccount.gender') }}
      </div>
      <v-radio-group v-model="account.gender" row dense class="mt-0" :rules="rules.required">
        <v-radio
          :label="$langs.get('myAccount.male')"
          value="m"
          :ripple="false"
        ></v-radio>
        <v-radio
          :label="$langs.get('myAccount.female')"
          value="w"
          :ripple="false"
        ></v-radio>
        <v-radio
          :label="$langs.get('myAccount.other')"
          value="o"
          :ripple="false"
        ></v-radio>
      </v-radio-group>

      <!-- <v-checkbox
        dense
        :ripple="false"
        class="text-caption mt-0 pt-0"
        v-model="checkbox"
        label="I agree to the terms & conditions"
        :rules="rules.checkbox"
        required
      ></v-checkbox> -->

      <!-- Consent here -->
      <v-checkbox v-model="agree" hide-details dense :ripple="false" :rules="rules.required">
        <template v-slot:label>
          <div>
            {{ $langs.get("auth.agreeWithTerms") }}
            <a href="/terms-and-conditions" target="_blank" @click.stop
              >{{ $langs.get("gen.terms") }}</a
            >
            &
            <a href="/privacy-policy" target="_blank" @click.stop
              >{{ $langs.get("gen.privacy") }}</a
            >
          </div>
        </template>
      </v-checkbox>

      <v-btn
        block
        depressed
        large
        class="rounded-sm mt-4"
        type="submit"
        color="primary darken-1"
        :loading="loading"
        >{{ $langs.get('auth.signup') }}</v-btn
      >
    </v-form>

    <!-- O Auth Sign up -->
    <!-- <div class="text-center pb-4">
            <div class="">Or Sign up With</div>
            <div>
                <v-btn
                    tile
                    depressed
                    large
                    width="120"
                    class="accent lighten-1"
                >
                    <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn
                    tile
                    depressed
                    large
                    width="120"
                    class="ml-2 accent lighten-1"
                >
                    <v-icon>mdi-google</v-icon>
                </v-btn>
            </div>
        </div> -->
  </v-card>
</template>

<script>
import user from "../../services/user";
import api from "../../services/api";

export default {
  data() {
    return {
      loading: false,
      account: {
        email: "",
        firstname: "",
        lastname: "",
        password: "",
        rePassword: "",
        birthdate: null,
        gender: null,
      },
      showField: {
        password: false,
        rePassword: false,
      },
      checkbox: false,
      datapicker: false,
      agree: false,
      rules: {
        name: [
          (v) => !!v || "required",
          (v) =>
            /(^[ก-๙|a-zA-Z]*$)/.test(v) || "Name must contain only letter ",
        ],
        email: [
          (v) => !!v || "required",
          (v) =>
            /^(?:[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*)@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/.test(
              v
            ) || "E-mail must be valid",
        ],
        password: [
          (v) => !!v || "required",
          (v) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d|@#$%^&+=!\.`\-?*~(){}\[\]<>\\:;'"_]{8,}$/.test(v) ||
            "Minimum 8 characters, at least one lowercase letter, one uppercase letter and one number",
        ],
        matchingPassword: [
          (v) => !!v || "required",
          (v) =>
            this.account.password == this.account.rePassword ||
            "Password is not match",
        ],
        required: [(v) => !!v || "required"],
      },
    };
  },
  methods: {
    async submit() {
      // console.log(this.$v)
      if (!this.$refs.form.validate()) return;
      let data = { ...this.account };
      delete data.rePassword;
      let [_ret, yy, mm, dd] = `${data.birthdate}`.match(/(\d+)-(\d+)-(\d+)/);
      data.birthdate = new Date(yy, parseInt(mm) - 1, dd).getTime();
      // console.log("sent ", data);
      this.loading = true;
      let result = await user.register(this.account);
      this.loading = false;
      if (result.success) {
        api.makeAlert("Register successfully.", "primary");

        if (typeof gtag !== 'undefined') {
          gtag("event", "sign_up", {});
        }

        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
      } else {
        api.makeAlert(result.msg, "error");
        // console.log("Some error occour");
      }
    },
  },
  metaInfo() {
    return {
      title: "Register",
      titleTemplate: "%s · ReptTown",
      meta: [{ name: "robots", content: "noindex" }],
    };
  },
};
</script>

<style scoped lang="scss">
</style>